import { createAction, props } from '@ngrx/store';

// vehicles
export const getVehicles = createAction(
  'get-vehicles',
  props<{ params: any }>(),
);

export const addVehicles = createAction(
  'add-vehicle',
  props<{ params: any }>(),
);
export const addVehiclesFailed = createAction('add-vehicle-failed');

export const editVehicles = createAction(
  'edit-vehicle',
  props<{ params: any }>(),
);
export const editVehiclesReceived = createAction('edit-vehicle-received');

export const getSelectedVehileDetails = createAction(
  'get-selected-vehicle-details',
);
export const getVehiclesReceived = createAction(
  'get-vehicles-received',
  props<{ params: any }>(),
);
export const getVehiclesFailed = createAction('get-vehicles-failed');

export const addNewVehicleRequest = createAction(
  'add-new-vehicle',
  props<{ params: any }>(),
);
export const addNewVehicleReceived = createAction(
  'add-new-vehicle-received',
  props<any>(),
);
export const addNewVehicleFailed = createAction(
  'add-new-vehicle-failed',
  props<any>(),
);

export const resetNewVehicleState = createAction('reset-vehicle-state');

// Delete Vehicle
export const deleteVehicle = createAction(
  'delete-vehicle',
  props<{ params: any; permitId: any }>(),
);
export const deleteVehicleSuccessfull = createAction(
  'delete-vehicle-successfull',
);
export const deleteVehicleFailed = createAction('delete-vehicle-failed');

// Edit State Registration Date
export const editStateRegistrationDate = createAction(
  'edit-state-registration-date',
  props<{ params: any; permitId: any }>(),
);
export const editStateRegistrationDateSuccessfull = createAction(
  'edit-state-registration-date-successfull',
);
export const editStateRegistrationDateFailed = createAction(
  'edit-state-registration-date-failed',
);

// Submit Vehicle For Review
export const submitVehicleForReview = createAction(
  'submit-vehicle-for-review',
  props<{ params: any; permitId: any }>(),
);
export const submitVehicleForReviewSuccessfull = createAction(
  'submit-vehicle-for-review-successfull',
);
export const submitVehicleForReviewFailed = createAction(
  'submit-vehicle-for-review-failed',
);

export const submitForReviewPopup = createAction(
  'submit-for-review-popup',
  props<{ params: boolean }>(),
);